'use client'

import { PlayIcon } from '@/components/icons/PlayIcon'
import { VideoDialog } from '@/components/shared/video-dialog'
import { Button } from '@/components/ui/button'
import { useIsMobile } from '@/hooks/use-is-mobile'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

export function Tutorial() {
  const [open, setOpen] = useState(false)
  const isMobile = useIsMobile()

  const t = useTranslations('DigitalCard')

  const url = isMobile ? '/video/vertical.mp4' : '/video/digital-card.mp4'
  return (
    <div id="tutorial" className="space-y-16 md:space-y-25">
      <div className="relative mx-auto flex h-117.5 max-w-260 flex-col items-center justify-center overflow-hidden rounded-3xl bg-[url('@/assets/images/digital-card/tutorial-mobile.png')] bg-cover bg-center md:rounded-[48px] lg:bg-[url('@/assets/images/digital-card/tutorial.png')]">
        <div className="absolute top-0 right-0 bottom-0 left-0 flex h-full w-full items-center justify-center bg-black/10">
          <Button
            onClick={() => setOpen(true)}
            icon={<PlayIcon />}
            variant="ghost"
            aria-label="Play"
          />
        </div>
        <VideoDialog
          open={open}
          onClose={() => setOpen(false)}
          videoUrl={url}
        />
      </div>

      <p className="bg-primary-50 text-body-3 mx-auto w-fit rounded-xl px-8 py-3 text-center leading-5">
        {t('tutorial.content')}
      </p>
    </div>
  )
}
